import { LitElement, TemplateResult, html, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';
import { AdoptedStyleSheets } from '../../controllers/adopted-stylesheets';
import globalStyles from './nuvance-header-basic.global.pcss?inline';
import innerStyles from './nuvance-header-basic.inner.pcss?inline';
import { SlotHelper } from '../../controllers/slot-helper';

/**
 * The Nuvance Header Basic component
 * @element nuvance-header-basic
 *
 * @slot logo - Named slot for logo content.
 * @slot link - Named slot for link content.
 */
@customElement('nuvance-header-basic')
export class NuvanceHeaderBasic extends LitElement {
  adoptedStyleSheets = new AdoptedStyleSheets(this, {
    globalCSS: globalStyles,
    encapsulatedCSS: innerStyles,
  });
  // SlotHelper instance to manage and test slots
  private slots = new SlotHelper(this);

  render(): TemplateResult {
    return html`
      <div class="header-basic">
        ${this.slots.isNotEmpty('logo')
          ? html` <slot name="logo"></slot> `
          : nothing}
        ${this.slots.isNotEmpty('link')
          ? html` <slot name="link"></slot> `
          : nothing}
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'nuvance-header-basic': NuvanceHeaderBasic;
  }
}
